import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import {
  convertToQuery,
  getDeviceType,
  getScreenName,
  removeDefaultParams,
} from '../../../Utils/helper';
import { getRouterLocale } from '../../../Utils/i18Utils/constant';
import RecentSearches from '../NewHeader/Recent/RecentSearch';
import TrendingSearches from '../NewHeader/Trending/TrendingSearches';
import { SearchBox, SearchItem } from './styled';
import { SearchLoaderContainer } from '../../Search/SearchResultComponent/styled';
import SearchLoader from '../../Search/SearchLoader/SearchLoader';
import Image from 'next/image';
import AnchorCoverTag from '../../StoreHomePage/AnchorCoverTag';
import AutoKeywords from './AutoKeywords';
import { fireRecommendedEvent } from './common';
import { fireEvent } from '../../../Utils/fireEvent';

export default function SerachResult(props) {
  const {
    searchData,
    searchString,
    searchBoxRef,
    recentSearch,
    recentSearchClickHandler,
    trendingSearchClickHandler,
    trendingSearchData,
    showLoader,
    changeToSearchRoute,
    setShowSearchSectionClass,
  } = props;
  const router = useRouter();
  const [cardEffect, setCardEffect] = useState(-1);
  useEffect(() => {
    if (
      searchString === '' &&
      getDeviceType() == 'desktop' &&
      document.activeElement.id != 'searchInput'
    ) {
      searchBoxRef.current.style.display = 'none';
    } else if (searchBoxRef.current) {
      searchBoxRef.current.style.display = 'block';
    } else {
      searchBoxRef.current.style.display = 'block!important';
    }
  }, [searchString]);
  useEffect(() => {
    if (getDeviceType() == 'mWeb') {
      document.body.onclick = () => {
        searchBoxRef.current
          ? (searchBoxRef.current.style.display = 'block')
          : null;

        document.body.classList.add('noScroll');
      };
    }
    return () => {
      document.body.onclick = null;
      document.body.classList.remove('noScroll');
    };
  }, []);
  const searchItemHandler = (index, url, item, event) => {
    fireEvent({
      category: 'clicked_search_result',
      screen_name: getScreenName(),
      support_variable: searchString,
      content_type: 'product',
      position: index,
      id: item?.id,
    });
    let web_url = item?.web_url;
    if (web_url.includes('https://mylofamily.com')) {
      web_url = item?.web_url?.split('https://mylofamily.com')[1];
    }
    const q = convertToQuery(removeDefaultParams(router.query));
    let paramString = q ? '?' + q : '';
    router.push(web_url + paramString, '', {
      locale: getRouterLocale(router),
    });
    setTimeout(() => {
      setShowSearchSectionClass(false);
    }, [200]);
    event.stopPropagation();
  };
  const autoKeywordsHandler = (e, string, index) => {
    fireRecommendedEvent(string);
    e.stopPropagation();
    setTimeout(() => {
      changeToSearchRoute(e, string);
    }, 100);

    setCardEffect(index);
  };
  return (
    <>
      <SearchBox ref={searchBoxRef} id="searchresult">
        <RecentSearches
          recentSearchClickHandler={recentSearchClickHandler}
          recentSearch={recentSearch}
          searchData={searchData}
        />

        {showLoader ? (
          <SearchLoaderContainer>
            <SearchLoader />
          </SearchLoaderContainer>
        ) : (
          searchData?.map((item, index) => {
            const regex = new RegExp(searchString, 'gi');

            let text = item?.name;
            text = text?.replace(/(<span class="highlight">|<\/span>)/gim, '');

            const newText = text.replace(
              regex,
              '<span class="highlight">$&</span>',
            );
            const category_name = item?.key;
            const path_image =
              item?.image_path || item?.mobileWebIcon || item?.icon;
            if (item?.key === 'keywords')
              return (
                <AutoKeywords
                  newText={newText}
                  index={index}
                  cardEffect={cardEffect}
                  autoKeywordsHandler={autoKeywordsHandler}
                  string={item?.name}
                />
              );
            if (path_image)
              return (
                <AnchorCoverTag
                  url={item?.web_url}
                  key={`searches-${index}`}
                  cardEffect={index === cardEffect ? 'lowOpacity' : ''}
                  callbackFunction={searchItemHandler}
                  element={item}
                >
                  <SearchItem
                    key={index}
                    onClick={() => {
                      setCardEffect(index);
                    }}
                  >
                    <div className="left_portion">
                      <Image
                        src={path_image}
                        alt=""
                        height={32}
                        width={32}
                        quality={100}
                        style={{
                          objectFit: 'contain',
                        }}
                      />
                    </div>
                    <div className="category_text">
                      <span
                        dangerouslySetInnerHTML={{
                          __html: newText,
                        }}
                        className="search_text"
                      ></span>
                      {category_name ? (
                        <div className="category_field">
                          in{' '}
                          <span className="category_class">
                            {category_name}
                          </span>
                        </div>
                      ) : null}
                    </div>
                  </SearchItem>
                </AnchorCoverTag>
              );
          })
        )}
        <TrendingSearches
          trendingSearchClickHandler={trendingSearchClickHandler}
          // setTrendingSearchData={setTrendingSearchData}
          trendingSearchData={trendingSearchData}
        />
      </SearchBox>
    </>
  );
}
